import React from 'react';
import { Card, Col, Row, Form } from 'react-bootstrap';
import { useSelector } from 'react-redux';

import { Formik } from 'formik';
import * as Yup from 'yup';

import { DefaultSpinnerCenter } from '@components/Loader/Loader';
import { PayPalButtonWrapper } from '@components/Paypal/Paypal';
import { Page500 } from '@containers/ErrorPages';
import { billingApi } from '@reducers/billing';

const schema = Yup.object({
  paypalAccept: Yup.boolean().required(),
});

export const BalanceTopUp = () => {
  const { login } = useSelector((state) => state.auth.user);
  const { data, isLoading, isError, isFetching } =
    billingApi.useGetBalanceTopUpOptionsQuery({ login });

  if (isLoading || isFetching) {
    return <DefaultSpinnerCenter />;
  }
  if (isError) {
    return <Page500 />;
  }
  return (
    <Card>
      <Card.Header className="bg-didxl text-white">
        Top-up your account
      </Card.Header>
      <Card.Body>
        <Formik
          enableReinitialize
          validationSchema={schema}
          initialValues={{
            amount: data.data[0].value,
            paypalAccept: false,
          }}
          onSubmit={() => {}}
        >
          {({ handleChange, handleBlur, values }) => (
            <Form>
              <Row>
                <Col className="text-center offset-1" md={10}>
                  <strong>Currency:</strong> {data.currency.toUpperCase()}
                  <br />
                  <Form.Group controlId="formGroupTopUpAmount">
                    <Form.Label>Choose amount: </Form.Label>
                    <Form.Select
                      id="amount"
                      name="amount"
                      value={values.amount}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className="form-control input-sm max-width text-center"
                      size="sm"
                    >
                      {data.data.map(
                        ({ value, value_with_fee: valueWithFee }) => (
                          <option key={value} value={value}>
                            {valueWithFee}
                          </option>
                        )
                      )}
                    </Form.Select>
                  </Form.Group>
                  <hr />
                </Col>
              </Row>
              <Row>
                <Col className="text-center">
                  <PayPalButtonWrapper
                    currency={data.currency.toUpperCase()}
                    orderBody={{ amount: values.amount }}
                    showSpinner
                  />
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
      </Card.Body>
    </Card>
  );
};
